<template>
  <div class="updateLog">
    <router-view></router-view>
    
    <ContentView  v-if="isDetail==false">
      <template slot="operateLeft">
        <!-- <el-input class="enter-input" v-model="searchVal"  size="small" placeholder="请输入内容" @keyup.enter.native="search"></el-input> -->
        <el-button style="margin-left: 15px;" size="small" @click="addNotice">新增</el-button>
      </template>
      <template slot="operateRight"></template>
      <el-table slot="contentBox" :data="tableData"  border @row-click="onDetail" style="width: 100%">
        <el-table-column prop="fileName"  label="文件名称"></el-table-column>
        <el-table-column prop="uploaderId" label="上传人" ></el-table-column>
        <el-table-column prop="uploadDate" label="上传时间" ></el-table-column>
        
        <el-table-column prop="createdTime" label="操作" width="100">
            <template slot-scope="scope">
            <el-button @click.stop="onEdit(scope.row)" type="text">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
    </ContentView>
    <el-dialog title="上传文件" :visible.sync="dialogFormVisible">
        <el-form :model="form">
            <el-form-item label="上传文件" >
                <el-upload
              class="upload-demo"
              :before-upload="handlePreview"
              :http-request="myUpload"
              :limit="1"
              :file-list="fileList">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                </el-upload>
            </el-form-item>
            <el-form-item label="备注" >
                <el-input  type="textarea" v-model="form.remark" autocomplete="off"></el-input>
            </el-form-item>
            
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button style="color:#fff" type="primary" @click="duAddFile">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import ContentView from "@/components/ContentView";
import apiPub from '@/api/public'
export default {
  name: "updateFile",
  data() {
    return {
      tableData: [],
      searchVal:"",
       options:[],
       FileData:{},
       fileList:[],
       dialogFormVisible:false,
       form:{
           remark:""
       },
    input:"",
      win: false,
      value: "",
      timesRun: 0,
      isDetail:false
    };
  },
  components: {
    ContentView
  },
  watch:{
      $route(to,from){
        console.log(to);
        // this.controlRouter()
        
        if (to.name != 'updateFile') {
          this.isDetail = true;
        } else {
          this.isDetail = false;
          this.search()
        }
    }
  },
  created() {
      console.log('wwwww')
    this.search();
    this.controlRouter()
  },
  methods: {
    
    //---------------查询区域--------begin-----------
    controlRouter() {
      // console.log(this.$router.currentRoute)
       if (this.$router.currentRoute.name != 'updateFile') {
        this.isDetail = true;
      } else {
        this.isDetail = false;
      }
    },
    search(){
      this.getlist()
    },
    addNotice(){
        this.dialogFormVisible=true;
    //   this.$router.push({
    //     path: "/updateFile/updateForm",
    //     query: { }
    //   });
    },
     handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },
    
    //---------------业务区域--------end-----------

     handlePreview(File){
      console.log(File)
      this.FileData=File;
    },
    myUpload(e){
      let formdata = new FormData();
    },
     uploadHeaders(){
      return{Authorization: "Bearer " + getToken()};
      // return 'Authorization' = "Bearer " + getToken()
    },
    duAddFile(){
        const that = this;
        var userinfo = JSON.parse(localStorage.getItem("userinfo"));
        // var jwtCode = myJwt.encode(config.data, store.getters.token)
        // config.headers["Authorization"] = "Bearer " + store.getters.token
    //   var jwtCode = myJwt.encode(config.data, store.getters.token)
    // console.log(store.getters.token)
    //   config.headers["JWT"] = window.btoa(JSON.stringify({"typ":"JWT","alg":"HS256"}));
    //   config.headers["X-TOKEN"] = jwtCode;
      this.listLoading = true;
      const fd = new FormData()
      fd.append('file', this.FileData)
      fd.append('Remarks', this.form.remark)
      fd.append('UserID',userinfo.id)
      
      fd.append('UserName',userinfo.realName)
        //   $http.onUploadFile(apiPub.UploadpublishFile,fd,function(el){
        //       console.log(el)
        //        this.$message({
        //           message: '添加成功!',
        //           type: 'success'
        //         })
        //         that.onSearch();
        //         this.dialogVisible=false;
        //   })
       var obj = {
        "url": apiPub.UploadpublishFile,
            "data":fd
        };
        $http.request(obj,false,function(res) {
            console.log(res)
            that.$message({
                message: '添加成功!',
                type: 'success'
            })
            that.search();
            that.dialogVisible=false;
            // that.tableData=res.data;
        })
    },
    onSave(){
      
      var that=this;
      var obj = {
        "url": apiPub.AddNotice,
        "data":{
          "Content":this.form.Content,
          "Nstate":"0",
          "PushTime":this.form.PushTime,
          "PushUser":this.form.PushUser,
          "Title":this.form.Title
        }
      };
      $http.request(obj,false,function(res) {
        console.log(res)
        that.tableData=res.data;
      })
    },
    
    //---------------表格操作--------begin-----------
    getlist(){
      var that=this;
      var SearchText=this.searchVal||""
      var obj = {
        "url": apiPub.Publishziplist,
        "data":{
          SearchText:SearchText,
          OrdFild:"createdTime",
          OrdSort:'desc'
        }
      };
      $http.request(obj,false,function(res) {
          
        // console.log(res)
        that.tableData=res.data;
      })
    },
    onEdit(row){
        
        // let a = document.createElement('a')
        // a.href =row.fileCode
        // a.click();
        // const blob = new Blob([res.data])
        //   const fileName = row.fileName;
        //   const link = document.createElement('a')
        //   link.download = fileName
        //   link.style.display = 'none'
        //   link.href = row.fileCode
        //   document.body.appendChild(link)
        //   link.click()
        //   URL.revokeObjectURL(link.href)
        //   document.body.removeChild(link)
          window.open(row.fileCode,'_blank')
        // this.$router.push({path: '/updateLog/updateForm', query: {id:e.id,type:'edit'}});
    },
    onDetail(e){
       this.$router.push({path: '/updateLog/updateForm', query: {id:e.id,type:'detail'}});
       return;
    }
    /// -----------------------分页--begin-----------------------------
    /// -----------------------分页--end-------------------------------
  }
};
</script>
<style scoped>
.enterprise {
  /* padding: 20px; */
  background: #fff;
}
.org-logo {
  width: 40px;
  height: 40px;
}
.enter-input{
    width: 200px;

}
.enter-input+.enter-input{
    margin-left: 15px;
}
.el-form-item{
    margin-bottom: 10px;
}
</style>
